import { type IntersectionSlugType } from '@/defs/observer'

import { getIntersectionConfig } from './getIntersectionConfig'

export const unobserveIntersection = (slug: IntersectionSlugType, el: Element) => {
  const config = getIntersectionConfig(slug)
  if (!config) return
  config.callbacks.delete(el)
  config.observer.unobserve(el)
}
